import Sidebar from '@rio-cloud/rio-uikit/Sidebar';
import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { getSelectedServiceOption, serviceOrdersSlice } from '../../../reducers/serviceOrdersSlice';
import { ServiceOrderOrOptionSidebarHeader } from '../../shared/sidebar/ServiceOrderOrOptionSidebarHeader';
import { ServiceOption } from '../serviceOption.types';
import { ServiceOptionSidebarFooter } from './ServiceOptionSidebarFooter';
import { ServiceOptionSidebarForm } from './ServiceOptionSidebarForm';

export const ServiceOptionSidebar: FunctionComponent = () => {
    const selectedServiceOption = useAppSelector(getSelectedServiceOption);
    return (
        <ServiceOptionSidebarInternal selectedServiceOption={selectedServiceOption} key={selectedServiceOption?.id} />
    );
};

const ServiceOptionSidebarInternal = ({
    selectedServiceOption,
}: {
    selectedServiceOption: ServiceOption | undefined;
}) => {
    const dispatch = useAppDispatch();

    const closeSidebar = () => {
        dispatch(serviceOrdersSlice.actions.deselectServiceOption());
    };

    const sidebarProperties = {
        showHeaderBorder: true,
        resizable: true,
        position: Sidebar.RIGHT,
        minWidth: 400,
        maxWidth: 550,
        width: 550,
        fly: true,
    };

    if (selectedServiceOption === undefined) {
        return <Sidebar {...sidebarProperties} closed />;
    }

    const title = (
        <div className="text-size-16">
            <div>
                <FormattedMessage
                    id="outboundPortal.serviceOption.sidebar.title"
                    values={{ amount: selectedServiceOption.services.length }}
                />
            </div>
        </div>
    );

    return (
        <Sidebar
            {...sidebarProperties}
            title={title}
            titleClassName="padding-left-10"
            closed={false}
            onClose={closeSidebar}
            footer={<ServiceOptionSidebarFooter onClose={closeSidebar} />}
            footerClassName="margin-right-10"
        >
            <ServiceOrderOrOptionSidebarHeader serviceOrderOrOption={selectedServiceOption} />
            <ServiceOptionSidebarForm serviceOption={selectedServiceOption} />
        </Sidebar>
    );
};
